import React, { useState, useCallback, useEffect } from 'react'
import { useLocation, useHistory } from 'react-router-dom'

export const altaState = {
  paso: 1,
  verified: true,
  setVerified: () => console.log('verifica que puede avanzar'),
  setCallback: () => console.log('callback para guardar datos'),
  next: () => console.log('avanza'),
  back: () => console.log('retrocede')
}

const routes = {
  '/ddjj/alta/terminos': 1,
  '/ddjj/alta/datos-contribuyente': 2,
  '/ddjj/alta/datos-actividades': 3,
  '/ddjj/alta/comprobante': 4,
  '/ddjj/alta/error': 5
}

function getUrl(routes, target) {
  return Object.keys(routes)[target - 1]
}

export const AltaContext = React.createContext(altaState)

export function AltaProvider({ children }) {
  const [paso, setPaso] = useState(1)
  const [verified, setVerified] = useState(false)
  const [cb, setCB] = useState(() => () => false)
  const [loading, setLoading] = useState(false)

  const location = useLocation()
  const history = useHistory()

  const setCallback = useCallback(
    (callb) => {
      setCB(() => () => callb())
    },
    [setCB]
  )

  useEffect(() => {
    let next = getUrl(routes, paso)
    if (next !== location.pathname) {
      history.push(getUrl(routes, paso), location.state)
    }
  }, [paso, history, location.pathname, location.state])

  const next = async () => {
    setLoading(true)
    let result = await cb()

    if (verified && result) {
      setPaso((n) => (n < 4 ? n + 1 : 4))
    }

    setLoading(false)
  }
  const back = () => setPaso((n) => (n === 1 ? 1 : n - 1))

  return (
    <AltaContext.Provider
      value={{
        paso,
        next,
        back,
        verified,
        setVerified,
        setCallback,
        setPaso,
        loading
      }}
    >
      {children}
    </AltaContext.Provider>
  )
}
